import React, { Component } from "react";
import { Nav } from "react-bootstrap";
import { CardList } from "../../components/card-list/card-list.component";
import { CharityCardList } from "../../components/charity-card-list/charity-card-list.component";
import { SearchBox } from "../../components/search-box/search-box.component";
import { db } from "../../firebase/firebase.utils";
import Fuse from "fuse.js";
import { withRouter } from "react-router";
import { ReactComponent as GivingIcon } from "../../assets/ui-icons/giving.svg";
import { ReactComponent as NeedingIcon } from "../../assets/ui-icons/needing.svg";
import WarehousePhoto from "../../assets/3-warehouse-pic.png";
import FreeStandPhoto from "../../assets/free-stand-pic.png";
import PremiumRoomPhoto from "../../assets/premium-room-pic.png";

import "./homepage.styles.scss";

const VOUCHER_FORM_URL =
  "https://docs.google.com/forms/d/e/1FAIpQLScexH3YwEfCpiGgrlhIKvFjsDdmT-9fyg5wzJGl9GRVqmYx9g/viewform?usp=sharing&ouid=105292569075889813610";

const DROP_OFF_URL =
  "https://calendly.com/heartening-donations/drop-off-donations-at-heartening-s-warehouse";

const VOLUNTEER_URL =
  "https://calendly.com/heartening-donations/volunteering-in-the-heartening-warehouse";

const VENMO_URL = "https://account.venmo.com/u/Heartening";
const OPEN_COLLECTIVE_URL = "https://opencollective.com/heartening";

class HomePage extends Component {
  // component is already built into react so this leverages that
  constructor() {
    super(); // calls the constructor on the component class to give us access to state methods
    // now the state property exists on our App class

    this.state = {
      needItems: [], // sets some property on our state object
      charities: [],
      searchField: "",
      causesSearchField: "",
      activeSearchTab: "items",
    };
  }

  componentDidMount() {
    // life cycle method
    // GET NEED ITEMS and set to array on the needItems property of state

    // NON-RANDOMIZED PULL
    db.collection("needitems")
      .orderBy("priority", "desc")
      .get()
      .then((querySnapshot) => {
        const data = querySnapshot.docs.map((doc) => doc.data());
        this.setState({ needItems: data });
      });

    // GET ALL CHARITIES and set to array on the charities property of state
    db.collection("charities")
      .orderBy("name")
      .get()
      .then((querySnapshot) => {
        const data = querySnapshot.docs.map((doc) => doc.data());
        this.setState({ charities: data });
      });
  }

  handleChange = (e) => {
    this.setState({ searchField: e.target.value, title: e.target.value });
    this.props.history.push(`${e.target.value}`);
  };

  handleCausesChange = (e) => {
    this.setState({ causesSearchField: e.target.value });
  };

  handleSearchTabSelect = (tabKey) => {
    this.setState({ activeSearchTab: tabKey });
  };

  render() {
    const { needItems } = this.state;
    let { searchField } = this.state;

    const searchParam = this.props.match.params.searchParam;

    if (searchParam) {
      searchField = searchParam;
    }

    // FUSE - FUZZY SEARCH
    const options = {
      isCaseSensitive: false,
      includeScore: true,
      shouldSort: true,
      includeMatches: false,
      findAllMatches: false,
      minMatchCharLength: 2,
      location: 0,
      threshold: 0.3,
      distance: 100,
      useExtendedSearch: false,
      ignoreLocation: true,
      ignoreFieldNorm: false,
      keys: ["itemName", "description", "keywords", "category"], // add keywords in here
    };
    const fuse = new Fuse(needItems, options);
    // Change the pattern
    const pattern = searchField.toLowerCase();

    const fuseResults = fuse.search(pattern);

    const filteredNeedItems = searchField
      ? fuseResults.map((needItem) => needItem.item)
      : needItems;

    // FUSE - FUZZY SEARCH FOR CAUSES
    const { charities, causesSearchField, activeSearchTab } = this.state;
    const causesOptions = {
      isCaseSensitive: false,
      includeScore: true,
      shouldSort: true,
      includeMatches: false,
      findAllMatches: false,
      minMatchCharLength: 2,
      location: 0,
      threshold: 0.4,
      distance: 100,
      useExtendedSearch: false,
      ignoreLocation: true,
      ignoreFieldNorm: false,
      keys: ["name", "category"],
    };
    const causesFuse = new Fuse(charities, causesOptions);
    const causesPattern = causesSearchField.toLowerCase();
    const causesFuseResults = causesFuse.search(causesPattern);
    const filteredCharities = causesSearchField
      ? causesFuseResults.map((charity) => charity.item)
      : charities;

    return (
      <div className="HomePage">
        {/* THE 3 THINGS AT OUR LOCATION */}
        <section className="location-features">
          <h1 className="section-title">Visit our Austin warehouse</h1>
          <p className="section-subtitle">
            One location, three ways to thrift.
          </p>
          <div className="feature-card-row">
            <div className="feature-card feature-card--warehouse">
              <img
                className="feature-card-image"
                src={WarehousePhoto}
                alt="Racks of clothing inside the $3 Warehouse"
              />
              <h2>The $3 Warehouse</h2>
              <p>
                All adult clothing and shoes are just $3 each. Kids items are
                $2 and if you buy 10+ kids pieces they are $1.50 each.
              </p>
            </div>

            <div className="feature-card feature-card--stand">
              <img
                className="feature-card-image"
                src={FreeStandPhoto}
                alt="Heartening's Free Clothing Stand in the parking lot"
              />
              <h2>The Free Clothing Stand</h2>
              <p>
                Take what you need, no cost, no questions asked, from the
                stand in our parking lot. Open same hours as our warehouse.
              </p>
            </div>

            <div className="feature-card feature-card--premium">
              <img
                className="feature-card-image"
                src={PremiumRoomPhoto}
                alt="Curated racks of clothing inside the Premium Room"
              />
              <h2>The Premium Room</h2>
              <p>
                Acts as an ongoing fundraiser, selling vintage, unique, and
                name brand finds. 90% of items are just $15, with the top
                10% marked with a red tag.
              </p>
            </div>
          </div>
        </section>

        {/* $50 VOUCHER FOR THOSE IN NEED */}
        <section className="voucher-section">
          <h2 className="section-title">Need help? Get a free $50 voucher</h2>
          <p>
            If you're facing financial hardship and cannot afford clothing
            necessities, apply for a free $50 voucher to use in our $3
            Warehouse through a simple, 5-minute form. Generous neighbors in
            our community step forward to gift these requests.
          </p>
          <a
            className="voucher-cta-button"
            href={VOUCHER_FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            Apply for a voucher
          </a>
        </section>

        {/* GET INVOLVED - VOLUNTEER / DONATE MONEY / DONATE ITEMS */}
        <section className="get-involved-section">
          <h2 className="section-title">Get involved</h2>
          <div className="get-involved-row">
            <div className="get-involved-card">
              <h3>Volunteer</h3>
              <p>Help us sort, organize, and run the warehouse.</p>
              <a
                className="get-involved-link"
                href={VOLUNTEER_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Easy volunteer sign-up here →
              </a>
            </div>

            <div className="get-involved-card">
              <h3>Donate money</h3>
              <p>
                Every dollar helps us keep prices low and give away free
                clothing.
              </p>
              <a
                className="get-involved-link"
                href={VENMO_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Give on Venmo →
              </a>
              <a
                className="get-involved-link"
                href={OPEN_COLLECTIVE_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Give via Open Collective →
                <br />
                (tax deductible)
              </a>
            </div>

            <div className="get-involved-card">
              <h3>Donate items</h3>
              <p>Bring clothing and accessories by anytime we're open.</p>
              <a
                className="get-involved-link"
                href={DROP_OFF_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                Drop-off donations →
              </a>
            </div>
          </div>
        </section>

        {/* DE-EMPHASIZED SEARCH TOOL */}
        <section className="search-tool-section" id="search-tool">
          <p className="search-tool-label">
            Have an item we don't take at the warehouse? Search where else in
            Austin to donate it.
          </p>
          <div className="nav-container">
            <Nav
              className="pages-nav-pills"
              variant="pills"
              activeKey={activeSearchTab}
              onSelect={this.handleSearchTabSelect}
            >
              <Nav.Item>
                <Nav.Link eventKey="items">
                  <GivingIcon
                    className="giving-icon page-nav-icon"
                    width="27px"
                  ></GivingIcon>
                  items
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="causes">
                  <NeedingIcon
                    className="needing-icon page-nav-icon"
                    width="26px"
                  ></NeedingIcon>
                  causes
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>

          {activeSearchTab === "items" ? (
            <div className="SearchToDonate needs-item-search-container">
              <SearchBox
                className="needs-item-input"
                placeholder="search for an item to give away"
                handleChange={this.handleChange}
              />

              <CardList needItems={filteredNeedItems}></CardList>
            </div>
          ) : (
            <div className="SearchForCharity charity-search-container">
              <SearchBox
                className="charity-search-input"
                placeholder="search for a good cause"
                handleChange={this.handleCausesChange}
              />

              <CharityCardList charities={filteredCharities}></CharityCardList>
            </div>
          )}
        </section>
      </div>
    );
  }
}

export default withRouter(HomePage);
